import classnames from 'classnames';
import { Button, Modal } from 'components/common';
import { billing, useResponsiveWidth } from 'libs';

interface AddonPrice {
  name?: string;
  price?: number;
  stripe_price?: string;
  subscription_type?: string;
}

interface PurchaseAddonModalProps<P extends AddonPrice> {
  addon: { price: P };
  onHideModal: () => void;
  onPurchaseAddon: (price: P) => void;
  showModal: boolean;
}

const PurchaseAddonModal = <P extends AddonPrice>({
  addon,
  onHideModal,
  onPurchaseAddon,
  showModal,
}: PurchaseAddonModalProps<P>) => {
  const { isMinSm } = useResponsiveWidth();
  return (
    <Modal onHide={onHideModal} show={showModal} centered>
      <div className="p-3">
        <h4
          className="fw-bold"
          data-testid={`subscriptions-purchase-addon-modal-title-${addon.price.subscription_type}`}
        >
          Purchase add-on
        </h4>
        <div className="my-4">
          <strong>Subscription</strong>: {addon.price.name}
        </div>
        <div className="my-4" data-testid={`subscriptions-purchase-addon-modal-plan-${addon.price.subscription_type}`}>
          You will receive a new invoice for <strong>{billing.price(addon.price)}</strong>
        </div>
        <div className={classnames({ 'd-inline-block': isMinSm, 'col-md-12 mb-2': !isMinSm })}>
          <Button
            onClick={() => onPurchaseAddon(addon.price)}
            testId={`subscriptions-purchase-addon-modal-action-button-${addon.price.subscription_type}`}
            text="bold"
            variant="primary-dark"
            width={isMinSm ? 'content' : 'block'}
          >
            Confirm purchase
          </Button>
        </div>
        <div className={classnames({ 'd-inline-block ms-2': isMinSm, 'col-md-12 mb-2': !isMinSm })}>
          <Button onClick={onHideModal} text="bold" variant="border" width={isMinSm ? 'content' : 'block'}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PurchaseAddonModal;
